// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__unPBk","dark":"Divider_dark__Aegjw","box":"Divider_box__YNMp2","label":"Divider_label__4yWq3","dividerHorizontal":"Divider_dividerHorizontal__K5gld"};